<script>
import { HeartIcon, CurrencyDollarIcon, EnvelopeIcon } from '@heroicons/vue/24/outline'
import TwCard from '@/components/generic/tw-card.vue'
import TwButton from '@/components/generic/tw-button.vue'
import TwProgressBar from '@/components/generic/tw-progress-bar.vue'
import FundraiserSubscribeToUpdatesModal from '@/components/fundraiser-updates/fundraiser-subscribe-to-updates-modal.vue'
import TwTimeLeft from '@/components/generic/tw-time-left.vue'
import DonationsListGroup from '@/components/donations/public/donations-list-group.vue'
import FundraiserPageRaisedAmount from '@/components/fundraiser-pages/public/fundraiser-page-raised-amount.vue'
import TwModal from '@/components/generic/modal/tw-modal.vue'
import FundraiserPageSocialsShare from '@/components/fundraiser-pages/fundraiser-page-socials-share.vue'
export default {
  name: 'FundraiserPageRightColumn',
  components: { FundraiserPageSocialsShare, TwModal, FundraiserPageRaisedAmount, DonationsListGroup, TwTimeLeft, FundraiserSubscribeToUpdatesModal, TwProgressBar, TwButton, TwCard, HeartIcon, CurrencyDollarIcon, EnvelopeIcon },
  props: {
    fundraiserPage: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      ShowStickyBottomActions: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 600) { // Adjust scroll threshold as needed
        this.ShowStickyBottomActions = true;
      } else {
        this.ShowStickyBottomActions = false;
      }
    },
  },
}

</script>

<template>
  <div class="">
    <div class="lg:hidden flex flex-col items-center">
      <img v-if="fundraiserPage.cached.owner_avatar_url_small" class="h-20 w-20 rounded-full object-cover border-2" :src="fundraiserPage.cached.owner_avatar_url_small" :alt="fundraiserPage.cached.owner_name">
      <span v-else class="inline-flex h-20 w-20 items-center justify-center rounded-full bg-gray-200">
        <span v-if="fundraiserPage.cached.owner_initials" class="text-2xl leading-none text-gray-400">{{ fundraiserPage.cached.owner_initials }} </span>
      </span>
    </div>
    <div class="lg:rounded-2xl lg:shadow-sm lg:bg-white p-0 lg:p-6">
      <div v-if="fundraiserPage.cached">
        <fundraiser-page-raised-amount :fundraiser-page="fundraiserPage" />
        <tw-progress-bar :progress="fundraiserPage.cached.percentage_raised" />
        <tw-time-left v-if="fundraiserPage.deadline" class=" text-gray-600 text-sm" :deadline="fundraiserPage.deadline" detailed />
        <div class="mt-5">
          <tw-button :to="{name: 'FundraiserPageDonatePage', params:{ fundraiserPageId: fundraiserPage.id }}" block size="lg" class="w-full" variant="amber">
            Donate
          </tw-button>
          <div class="flex gap-3 mt-3">
            <tw-button block variant="outline" @click="$refs.shareModal.open()">
              Share
            </tw-button>
            <tw-button block variant="outline"  @click="$refs.subscribeToFundraiserModal.open()">
              Subscribe
            </tw-button>
          </div>
        </div>
      </div>
      <donations-list-group class="mt-8 hidden lg:block" :fundraiser-page="fundraiserPage" />
      <div class="hidden lg:static">
        <div class="uppercase mb-8">
          <heart-icon class="h-4 inline" /> Organizer: {{ fundraiserPage.cached.organizer_name }}
        </div>
        <div class="uppercase">
          <currency-dollar-icon class="h-4 inline" /> Beneficiary: {{ fundraiserPage.cached.beneficiary_name }}
        </div>
      </div>
      <fundraiser-subscribe-to-updates-modal ref="subscribeToFundraiserModal" :subscribable="fundraiserPage" />
      <tw-modal ref="shareModal" ok-only ok-text="Close" variant="secondary" title="Share this fundraiser" @ok="$refs.shareModal.close()">
        <fundraiser-page-socials-share :fundraiser-page="fundraiserPage" />
      </tw-modal>
    </div>
    <div v-show="ShowStickyBottomActions" class="mobile-donation-box border border-gray-100 shadow-md rounded-2xl bg-white p-4 lg:hidden">
      <div v-if="fundraiserPage.cached">
        <fundraiser-page-raised-amount :fundraiser-page="fundraiserPage" />
        <tw-progress-bar :progress="fundraiserPage.cached.percentage_raised" />
        <tw-button :to="{name: 'FundraiserPageDonatePage', params:{ fundraiserPageId: fundraiserPage.id }}" block size="lg" class="w-full mt-4" variant="amber">
          Donate
        </tw-button>
      </div>
    </div>
  </div>

</template>


<style scoped>

</style>
